// SupporterBadge Component
// Displays a supporter icon with a reusable RevoltTooltip

import { useRef, useState } from 'react';
import { RevoltTooltip } from './RevoltTooltip';

const DEFAULT_TOOLTIP_TEXT =
  'Financially supporting Revolt in any way (even one-time) gives you this badge and access to the Community tab.';

export function SupporterBadge({
  tooltipTitle = 'Supporter',
  tooltipText = DEFAULT_TOOLTIP_TEXT,
  tooltipMaxWidth = 320,
}) {
  const badgeRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <span
      ref={badgeRef}
      className="supporter-badge supporter-badge--interactive"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      onFocus={() => setIsOpen(true)}
      onBlur={() => setIsOpen(false)}
      tabIndex={0}
      aria-label="Supporter"
    >
      <span className="supporter-badge-icon" aria-hidden="true">
        <span className="supporter-badge-bg">
          <i className="fa-solid fa-check supporter-badge-icon-check"></i>
        </span>
      </span>

      <RevoltTooltip
        isOpen={isOpen}
        anchorRef={badgeRef}
        placement="bottom"
        maxWidth={tooltipMaxWidth}
      >
        <div className="revolt-tooltip-title">{tooltipTitle}</div>
        <div className="revolt-tooltip-body">{tooltipText}</div>
      </RevoltTooltip>
    </span>
  );
}

